import React from 'react';
import { Trophy, Target, ArrowRight, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function RankStatusHero() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-6" data-id="element-255">
      <div className="bg-[#0a1e5e] px-4 sm:px-6 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2" data-id="element-256">
        <div className="flex items-center gap-3 text-white min-w-0" data-id="element-257">
          <Trophy className="w-6 h-6 text-yellow-400 shrink-0" data-id="element-258" />
          <h2 className="text-lg font-bold truncate" data-id="element-259">Career Progression</h2>
        </div>
        <div className="text-blue-200 text-xs sm:text-sm font-medium" data-id="element-260">
          Your Path. Your Production. Your Future.
        </div>
      </div>

      <div className="p-4 sm:p-6 flex flex-col lg:flex-row gap-6 items-stretch" data-id="element-261">
        {/* Current Status */}
        <div className="flex-1 w-full bg-blue-50 rounded-xl p-5 sm:p-6 border border-blue-100 relative overflow-hidden min-w-0" data-id="element-262">
          <div className="absolute top-0 right-0 w-32 h-32 bg-blue-100 rounded-full -mr-10 -mt-10 opacity-50 pointer-events-none" data-id="element-263"></div>
          <div className="relative" data-id="element-264">
            <p className="text-sm font-bold text-blue-600 uppercase tracking-wider mb-1" data-id="element-265">
              Current Rank
            </p>
            <h3 className="text-2xl sm:text-3xl font-extrabold text-[#0a1e5e] mb-4 leading-tight break-words" data-id="element-266">
              LOAN OFFICER
            </h3>

            <div className="bg-white rounded-lg p-4 border border-blue-100 shadow-sm" data-id="element-267">
              <p className="text-xs text-gray-500 font-semibold uppercase mb-2 tracking-wider" data-id="element-268">
                Current Compensation
              </p>
              <div className="flex items-baseline gap-2 flex-wrap" data-id="element-269">
                <span className="text-2xl font-bold text-[#0a1e5e] leading-none" data-id="element-270">
                  80 BPS
                </span>
                <span className="text-sm text-gray-600 font-medium" data-id="element-271">Base</span>
              </div>
              <p className="text-sm text-gray-600 mt-2 leading-snug" data-id="element-272">
                Up to 110 BPS at 10+ units
              </p>
            </div>
          </div>
        </div>

        <div className="hidden lg:flex items-center justify-center text-gray-300 shrink-0" data-id="element-273">
          <ArrowRight className="w-10 h-10" data-id="element-274" />
        </div>

        {/* Next Target */}
        <div className="flex-[2] w-full bg-white rounded-xl p-5 sm:p-6 border border-gray-200 shadow-sm min-w-0" data-id="element-275">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3 mb-5" data-id="element-276">
            <div className="min-w-0" data-id="element-277">
              <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-1" data-id="element-278">
                Next Target
              </p>
              <h3 className="text-xl sm:text-2xl font-extrabold text-[#0a1e5e] flex items-center gap-2 leading-tight" data-id="element-279">
                <span className="break-words" data-id="element-280">SENIOR LOAN OFFICER</span>
                <Target className="w-5 h-5 text-blue-600 shrink-0" data-id="element-281" />
              </h3>
            </div>
            <div className="sm:text-right shrink-0" data-id="element-282">
              <p className="text-xs text-gray-500 font-semibold uppercase mb-1 tracking-wider" data-id="element-283">
                Target Comp
              </p>
              <p className="text-lg font-bold text-green-600 whitespace-nowrap" data-id="element-284">
                85 – 115 BPS
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-5 md:gap-6 relative" data-id="element-285">
            {/* OR badge - placed between grid columns on md+ */}
            <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10 bg-white border border-gray-200 text-[10px] font-bold px-2 py-0.5 rounded-full text-gray-500 shadow-sm pointer-events-none" data-id="element-286">
              OR
            </div>

            {/* Path 1: Tenure */}
            <div className="min-w-0" data-id="element-287">
              <div className="flex justify-between gap-2 text-sm mb-2" data-id="element-288">
                <span className="font-semibold text-gray-700" data-id="element-289">
                  Path 1: Tenure
                </span>
                <span className="text-gray-500 shrink-0 text-xs sm:text-sm" data-id="element-290">
                  1yr 4mo / 2yr
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5 mb-1.5 overflow-hidden" data-id="element-291">
                <div className="bg-blue-600 h-2.5 rounded-full" style={{
                width: '66%'
              }} data-id="element-292"></div>
              </div>
              <p className="text-xs text-gray-500" data-id="element-293">8 months remaining</p>
            </div>

            {/* Path 2: Units */}
            <div className="min-w-0" data-id="element-294">
              <div className="flex justify-between gap-2 text-sm mb-2 flex-wrap" data-id="element-295">
                <span className="font-semibold text-[#0a1e5e] flex items-center gap-1.5 flex-wrap" data-id="element-296">
                  Path 2: Units
                  <span className="bg-green-100 text-green-700 text-[10px] px-1.5 py-0.5 rounded uppercase font-bold whitespace-nowrap" data-id="element-297">
                    Closer
                  </span>
                </span>
                <span className="text-[#0a1e5e] font-bold shrink-0 text-xs sm:text-sm" data-id="element-298">
                  11 / 16 units
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5 mb-1.5 overflow-hidden" data-id="element-299">
                <div className="bg-green-500 h-2.5 rounded-full" style={{
                width: '68%'
              }} data-id="element-300"></div>
              </div>
              <p className="text-xs text-gray-600 font-medium" data-id="element-301">
                In any 4-month rolling period
              </p>
            </div>
          </div>

          <div className="mt-5 bg-blue-50 border border-blue-100 rounded-lg p-3 flex items-start gap-3" data-id="element-302">
            <CheckCircle2 className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" data-id="element-303" />
            <div className="min-w-0" data-id="element-304">
              <p className="text-sm font-semibold text-[#0a1e5e]" data-id="element-305">
                Action Plan
              </p>
              <p className="text-sm text-gray-700 leading-snug" data-id="element-306">
                Close <strong className="text-blue-700" data-id="element-307">5 more units</strong> in
                the next 2 months to qualify for Senior Loan Officer via the
                units path.
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}